module.exports = __webpack_public_path__ + "static/media/Team 6 EcoSix Logo - Akeem Perry.7d245631.png";